function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 7",
  cx: 118.5,
  cy: 17,
  rx: 118.5,
  ry: 17,
  fill: "rgba(129,129,129,0.17)"
});

function SvgTabletShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 34
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMzciIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAyMzcgMzQiPgogIDxlbGxpcHNlIGlkPSJFbGxpcHNlXzciIGRhdGEtbmFtZT0iRWxsaXBzZSA3IiBjeD0iMTE4LjUiIGN5PSIxNyIgcng9IjExOC41IiByeT0iMTciIGZpbGw9InJnYmEoMTI5LDEyOSwxMjksMC4xNykiLz4KPC9zdmc+Cg==";
export { SvgTabletShadow as ReactComponent };